import {createElement, Component, PropTypes} from 'rlink-react';
import {NavLink} from 'rlink-router/component';

export default function GameUpdateList ({gameUpdates, maxUpdates, theme}) {
  let updateItems = [];
  let index = gameUpdates.length - 1;
  while (updateItems.length < maxUpdates) {
    if (index >= 0) {
        let item = gameUpdates[index];
        updateItems.push(<li className={theme.GameUpdateItem}>
          <NavLink href={{
            view: 'article',
            params: {slug: item.slug},
            returnTransition: 'fade',
            transition: 'fade',
          }}>
            <span>{item.title}</span>
          </NavLink>
        </li>);

        index--;
      } else {
        updateItems.push(<li></li>);
      }
  }

  return <div>
    <h2>Game Updates</h2>
    <div className={theme.GameUpdates}>
      <ul className={theme.GameUpdatesList}>
        {updateItems}
      </ul>
    </div>
  </div>
}

GameUpdateList.propTypes = {
  gameUpdates: PropTypes.array,
  maxUpdates: PropTypes.number,
};

GameUpdateList.defaultProps = {
  maxUpdates: 5,
};

//TODO: implement themeable



// WEBPACK FOOTER //
// ./lib/rlink-blog/GameUpdateList.jsx